import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import navConfig from "../config/navConfig";
import ReportLinks from "../components/ReportLinks"; // ✅ Import component

const HomePage = () => {
  const { accounts, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress === "none" && accounts.length > 0) {
      // ✅ Auto-redirect to first report page
      const firstRoute = navConfig?.[0]?.pages?.[0]?.route;
      if (firstRoute) {
        navigate(firstRoute);
      }
    }
  }, [inProgress, accounts, navigate]);

  if (inProgress !== "none") {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>Welcome to Smart Pulse Dashboard</Typography>
      <ReportLinks /> {/* ✅ Render links for manual navigation */}
    </Box>
  );
};

export default HomePage;
